import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { fetchGet } from '../reduxactions/suprivisoractions/SupDocReportsActions';
import { useLocation, useParams } from 'react-router-dom';
import { fetchDocData1, fetchDocData2, fetchDocData3, fetchDocData4, UploadImageData, ViewImageData } from '../reduxactions/suprivisoractions/SupApproveActions';

import { RootState } from '../reducers';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import useEffectOnce from '../hooks/useEffectOnce';
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { FileUpload, FileUploadHandlerEvent } from 'primereact/fileupload';
import { SUPRIVISOR_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { Toast } from 'primereact/toast';
import { ScrollPanel } from 'primereact/scrollpanel';
var imageuser = require('../assets/img/userim.png');



export const ViewPatApplication = () => {
    const uid = window.sessionStorage.getItem('uid');

    const [globalFilter, setGlobalFilter] = useState('');
    const stepperRef = useRef(null);

    const [activeIndex, setActiveIndex] = useState(0);

    const location = useLocation();
    const dispatch = useDispatch();

    const [queryParams, setQueryParams] = useState(null);
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQueryParams(params.get("id") as any);
    }, [location]);
    const { id } = useParams();
    const getdata = useSelector((state: RootState) => state.sviewdocreports.get);
    const getdata1 = useSelector((state: RootState) => state.sviewapprovedapplication.getdetails1);
    const getdata2 = useSelector((state: RootState) => state.sviewapprovedapplication.getdetails2);
    const getdata3 = useSelector((state: RootState) => state.sviewapprovedapplication.getdetails3);
    const getdata4 = useSelector((state: RootState) => state.sviewapprovedapplication.getdetails4);
    const [fileName, setFileName] = useState('');


    //To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchGet(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDataAsync1 = async () => {
        try {
            await dispatch(fetchDocData1(id, uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    //To get data
    const fetchDataAsync2 = async () => {
        try {
            await dispatch(fetchDocData2(id, uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDataAsync3 = async () => {
        try {
            await dispatch(fetchDocData3(id, uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    //To get data
    const fetchDataAsync4 = async () => {
        try {
            await dispatch(fetchDocData4(id, uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const [message, setMessage] = useState('');


    useEffectOnce(() => {
        fetchDataAsync();
        fetchDataAsync1();
        fetchDataAsync2();
        fetchDataAsync3();
        fetchDataAsync4();
    }, [dispatch]);
    const [Adddocument, setAdddocument] = useState(false);
    const [doc_name, setDocument] = useState<string>('');
    const close = () => {
        setAdddocument(false);
        setfield(false);
    }
    const images = useSelector((state: RootState) => state.sviewapprovedapplication.image);
    const [selectedFile, setSelectFile] = useState<File | null>(null);
    const UploadManagerImage = async (event: FileUploadHandlerEvent) => {
        const files = event.files;
        if (files.length > 0) {
            const file = files[0];
            console.log("file:", file)
            console.log("called image function:", file)
            try {
                await dispatch(UploadImageData(file, id) as any);
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        }

    };
    const toast = useRef<Toast>(null);
    const addDataAsync = async () => {
        try {
            const payload = { aid: id, doctitle: doc_name, filename: images.filename, userid: uid, q: 8 };
            const apiname = SUPRIVISOR_API.sviewapprovedapplications;
            const response = await LoginService.getData(apiname, payload);
            if (toast.current) {
                toast.current.show({ severity: 'success', detail: response });
            }
            fetchDataAsync4();
            setAdddocument(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const [acceptfield, setfield] = useState(false);
    const view = useSelector((state: RootState) => state.sviewapprovedapplication.view);

    const viewupload = (rowData: any) => {
        assignData.current = { DocID: rowData.DocID }

        setfield(true);
        fetchDataAsyncdialog()
    };
    const assignData = useRef({ DocID: '' })

    const fetchDataAsyncdialog = async () => {
        try {
            const { DocID } = assignData.current;
            console.log("DocID", DocID)
            await dispatch(ViewImageData(DocID) as any);
        } catch (error) {
            console.error('Error deleting data:', error);
        }
    }

    //send messege
    const [sendMessege, setSendMessege] = useState<[]>([]);

    const SendMessegeFunction = async () => {
        try {
            const payload = { aid: id, message: message, userid: uid, q: 12 };
            const apiname = SUPRIVISOR_API.sviewapprovedapplications;
            const response = await LoginService.getData(apiname, payload);
            if (toast.current) {
                toast.current.show({ severity: 'success', detail: response });
            }
            fetchDataAsync2();
            setMessage('');
            setSendMessege(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/viewpatientapplications.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (

        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="col-16" style={{ textAlign: "right" }}>
                        <a
                            title="help"
                            onClick={(e) => openWindow(e, IUrl)}
                            style={{

                                color: "blue",
                                fontSize: 15, cursor: "pointer"
                            }}
                        >Help for this Page &nbsp;
                            <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                        </a>
                    </div>
                    <div className="content-wrapper">
                        <section className="content">
                            <div className="grid" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div className="col-left" style={{ display: 'flex', flexDirection: 'column', width: '25%' }}>
                                    {getdata1.map((response: any) => (
                                        <div className="col-12" style={{ marginBottom: '20px' }}>
                                            {/* <Panel header="" style={{ width: '100%' }}>
                                                <div className="widget-user-header bg-info" style={{ height: '100px', backgroundColor: 'rgb(255, 193, 7)', display: 'flex', alignItems: 'center', width: '100%' }}>
                                                    <img
                                                        src={response.photo}
                                                        alt="User Avatar"
                                                        style={{
                                                            width: '100px',
                                                            height: '60px',
                                                            borderRadius: '50%',
                                                            marginRight: '15px'
                                                        }}
                                                    />
                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <h2 className="widget-user-username" style={{ color: 'black', fontWeight: '200', fontSize: '25px', marginBottom: '10px' }}>
                                                            {response.pfname}
                                                        </h2>
                                                        <h3 className="widget-user-username" style={{ color: 'black', fontSize: '1.25rem', margin: '0', fontWeight: '400' }}>
                                                            Patient
                                                        </h3>
                                                    </div>
                                                </div>
                                                <div className='grid' style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                                    <strong style={{ width: '100px' }}>E-Mail</strong>
                                                    <p className="text-muted" style={{ backgroundColor: 'rgb(0, 123, 255)', color: 'white', borderRadius: '6px', textAlign: 'center', marginLeft: '10px', padding: '5px 10px' }}>
                                                        {response.pemail}
                                                    </p>
                                                </div>
                                                <hr style={{ width: '100%', border: '0.5px solid rgba(0, 0, 0, 0.1)', marginTop: '5px', marginBottom: '5px' }} />

                                                <div className='grid' style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                                    <strong style={{ width: '100px' }}>Phone</strong>
                                                    <p className="text-muted" style={{ backgroundColor: 'rgb(23, 162, 184)', color: 'white', borderRadius: '6px', textAlign: 'center', marginLeft: '10px', padding: '5px 10px' }}>
                                                        {response.pmobile}
                                                    </p>
                                                </div>
                                                <hr style={{ width: '100%', border: '0.5px solid rgba(0, 0, 0, 0.1)', marginTop: '5px', marginBottom: '5px' }} />

                                                <div className='grid' style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                                    <strong style={{ width: '100px' }}>City</strong>
                                                    <p className="text-muted" style={{ backgroundColor: 'rgb(40, 167, 69)', color: 'white', borderRadius: '6px', textAlign: 'center', marginLeft: '10px', padding: '5px 10px' }}>
                                                        {response.pcity}
                                                    </p>
                                                </div>
                                                <hr style={{ width: '100%', border: '0.5px solid rgba(0, 0, 0, 0.1)', marginTop: '5px', marginBottom: '5px' }} />

                                                <div className='grid' style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                                    <strong style={{ width: '100px' }}>State</strong>
                                                    <p className="text-muted" style={{ backgroundColor: 'rgb(220, 53, 69)', color: 'white', borderRadius: '6px', textAlign: 'center', marginLeft: '10px', padding: '5px 10px' }}>
                                                        {response.pstate}
                                                    </p>
                                                </div>
                                                <hr style={{ width: '100%', border: '0.5px solid rgba(0, 0, 0, 0.1)', marginTop: '5px', marginBottom: '5px' }} />

                                                <div className='grid' style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                                    <strong style={{ width: '100px' }}>Country</strong>
                                                    <p className="text-muted" style={{ backgroundColor: 'rgb(220, 53, 69)', color: 'white', borderRadius: '6px', textAlign: 'center', marginLeft: '10px', padding: '5px 10px' }}>
                                                        {response.CountryName}
                                                    </p>
                                                </div>
                                            </Panel> */}
                                            <Panel header="" style={{ width: '100%' }}>
                                                <div style={{ height: '100px', backgroundColor: 'rgb(255, 193, 7)', display: 'flex', alignItems: 'center', width: '100%' }}>
                                                    <img
                                                        src={response.photo}
                                                        alt="User Avatar"
                                                        style={{ width: '100px', height: '60px', borderRadius: '50%', marginRight: '15px' }}
                                                    />
                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <h2 style={{ color: 'black', fontWeight: '200', fontSize: '25px', marginBottom: '10px' }}>
                                                            {response.pfname}
                                                        </h2>
                                                        <h3 style={{ color: 'black', fontSize: '1.25rem', margin: '0', fontWeight: '400' }}>
                                                            Patient
                                                        </h3>
                                                    </div>
                                                </div>

                                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', gap: '15px' }}>
                                                    <strong style={{ width: '100px' }}>E-Mail</strong>
                                                    <span style={{ backgroundColor: 'rgb(0, 123, 255)', color: 'white', borderRadius: '6px', padding: '5px 10px' }}>
                                                        {response.pemail}
                                                    </span>
                                                </div>
                                                <hr />

                                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', gap: '15px' }}>
                                                    <strong style={{ width: '100px' }}>Phone</strong>
                                                    <span style={{ backgroundColor: 'rgb(23, 162, 184)', color: 'white', borderRadius: '6px', padding: '5px 10px' }}>
                                                        {response.pmobile}
                                                    </span>
                                                </div>
                                                <hr />

                                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', gap: '15px' }}>
                                                    <strong style={{ width: '100px' }}>City</strong>
                                                    <span style={{ backgroundColor: 'rgb(40, 167, 69)', color: 'white', borderRadius: '6px', padding: '5px 10px' }}>
                                                        {response.pcity}
                                                    </span>
                                                </div>
                                                <hr />

                                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', gap: '15px' }}>
                                                    <strong style={{ width: '100px' }}>State</strong>
                                                    <span style={{ backgroundColor: 'rgb(220, 53, 69)', color: 'white', borderRadius: '6px', padding: '5px 10px' }}>
                                                        {response.pstate}
                                                    </span>
                                                </div>
                                                <hr />

                                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', gap: '15px' }}>
                                                    <strong style={{ width: '100px' }}>Country</strong>
                                                    <span style={{ backgroundColor: 'rgb(220, 53, 69)', color: 'white', borderRadius: '6px', padding: '5px 10px' }}>
                                                        {response.CountryName}
                                                    </span>
                                                </div>
                                            </Panel>

                                            {/* Doctor Panel */}
                                            <Panel header="" style={{ width: '100%', marginTop: '20px' }}>
                                                <div style={{ height: '100px', backgroundColor: 'rgb(255, 193, 7)', display: 'flex', alignItems: 'center', width: '100%' }}>
                                                    {/* <img
                                                        src={response.photo}
                                                        alt="User Avatar"
                                                        style={{ width: '100px', height: '60px', borderRadius: '50%', marginRight: '15px' }}
                                                    /> */}
                                                    <img
                                                        src={response.hosp_photo}
                                                        alt="User Avatar"
                                                        style={{ width: '100px', height: '60px', borderRadius: '50%', marginRight: '15px' }}
                                                    />
                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <h2 style={{ color: 'black', fontWeight: '200', fontSize: '25px', marginBottom: '10px' }}>
                                                            {response.hospitalname}
                                                        </h2>
                                                        <h3 style={{ color: 'black', fontSize: '1.25rem', margin: '0', fontWeight: '400' }}>
                                                            Hospitial Information
                                                        </h3>
                                                    </div>
                                                </div>
                                                {/*
                                                 * Author: Anuradha ,Date: 2026-02-05 
                                                 * Description:Hospitial Info and photo 
                                                 */}



                                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px', marginBottom: '5px', gap: '15px' }}>
                                                    <strong style={{ width: '100px' }}>E-Mail</strong>
                                                    <span style={{ backgroundColor: 'rgb(0, 123, 255)', color: 'white', borderRadius: '6px', padding: '5px 10px' }}>
                                                        {response.email}
                                                    </span>
                                                </div>
                                                <hr />

                                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', gap: '15px' }}>
                                                    <strong style={{ width: '100px' }}>Phone</strong>
                                                    <span style={{ backgroundColor: 'rgb(23, 162, 184)', color: 'white', borderRadius: '6px', padding: '5px 10px' }}>
                                                        {response.phone}
                                                    </span>
                                                </div>
                                                <hr />

                                                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                                    <strong style={{ width: '100px' }}>City</strong>
                                                    <span style={{ backgroundColor: 'rgb(40, 167, 69)', color: 'white', borderRadius: '6px', padding: '5px 10px' }}>
                                                        {response.city}
                                                    </span>
                                                </div>
                                            </Panel>

                                            {/* Doctor Panel */}
                                            {/* <Panel header="" style={{ width: '100%', marginTop: '20px' }}>
                                                <div className="widget-user-header bg-info" style={{ height: '100px', backgroundColor: 'rgb(255, 193, 7)', display: 'flex', alignItems: 'center', width: '100%' }}>
                                                    <img
                                                        src={response.hosp_photo}
                                                        alt="User Avatar"
                                                        style={{
                                                            width: '100px',
                                                            height: '60px',
                                                            borderRadius: '50%',
                                                            marginRight: '15px'
                                                        }}
                                                    />
                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <h2 className="widget-user-username" style={{ color: 'black', fontWeight: '200', fontSize: '25px', marginBottom: '10px' }}>
                                                            {response.hospitalname}
                                                        </h2>
                                                        <h3 className="widget-user-username" style={{ color: 'black', fontSize: '1.25rem', margin: '0', fontWeight: '400' }}>
                                                            Medical
                                                        </h3>
                                                    </div>
                                                </div>
                                                <div className='grid' style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                                    <strong style={{ width: '100px' }}>E-Mail</strong>
                                                    <p className="text-muted" style={{ backgroundColor: 'rgb(0, 123, 255)', color: 'white', borderRadius: '6px', textAlign: 'center', marginLeft: '10px', padding: '5px 10px' }}>
                                                        {response.email}
                                                    </p>
                                                </div>
                                                <hr style={{ width: '100%', border: '0.5px solid rgba(0, 0, 0, 0.1)', marginTop: '5px', marginBottom: '5px' }} />

                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                    <strong style={{ width: '100px' }}>Phone</strong>
                                                    <p className="text-muted" style={{ backgroundColor: 'rgb(23, 162, 184)', color: 'white', borderRadius: '6px', textAlign: 'center', marginLeft: '10px', padding: '5px 10px' }}>
                                                        {response.phone}
                                                    </p>
                                                </div>
                                                <hr style={{ width: '100%', border: '0.5px solid rgba(0, 0, 0, 0.1)', marginTop: '5px', marginBottom: '5px' }} />

                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                    <strong style={{ width: '100px' }}>City</strong>
                                                    <p className="text-muted" style={{ backgroundColor: 'rgb(40, 167, 69)', color: 'white', borderRadius: '6px', textAlign: 'center', marginLeft: '10px', padding: '5px 10px' }}>
                                                        {response.city}
                                                    </p>
                                                </div>
                                            </Panel> */}
                                        </div>
                                    ))}
                                </div>

                                <div className="col-right" style={{ width: '70%', marginRight: '50px' }}>
                                    {getdata1.map((response: any) => (
                                        <Panel header="Application Details" style={{ minHeight: '500px', width: '100%', padding: '20px' }} key={response.application_ID}>
                                            <div className="grid">
                                                <div className="col-12 md:col-12 lg:col-6">
                                                    {[
                                                        { label: 'Application ID', value: response.application_ID },
                                                        { label: 'Application Type', value: response.type },
                                                        { label: 'Patient Name', value: response.pfname },
                                                        { label: 'Email ', value: response.pemail },
                                                        { label: 'Phone No', value: response.pmobile },
                                                        { label: 'Identity Proof', value: response.proof_type },
                                                        { label: 'Type Identity', value: response.proof_ID },
                                                        { label: 'Card Number', value: response.health_card_number },
                                                        { label: 'City', value: response.pcity },
                                                        { label: 'State', value: response.pstate },
                                                        { label: 'Country', value: response.CountryName },
                                                    ].map(({ label, value }) => (
                                                        <div className='grid' style={{ display: 'flex', alignItems: 'center', marginBottom: '40px' }} key={label}>
                                                            <strong style={{ marginRight: '20px', flex: '1' }}>{label} :</strong>
                                                            <p className="text-muted" style={{ flex: '2', margin: 0 }}>{value}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                                <div className="col-12 md:col-12 lg:col-6">
                                                    {[
                                                        { label: 'Card No', value: response.health_card_number },
                                                        { label: 'Sickness', value: response.Sickness },
                                                        { label: 'Description', value: response.sickness_description },
                                                        { label: 'Preferred Doctor', value: response.dname },
                                                        { label: 'Preferred Hospital', value: response.hospitalname },
                                                        // { label: 'Preferred City', value: response.prefered_city },
                                                        { label: 'Preferred State', value: response.prefered_state },
                                                        { label: 'Preferred Country', value: response.prefered_country },
                                                        { label: 'Status', value: response.status },
                                                        { label: 'Reason', value: response.rejection_reason },



                                                        { label: 'Preferred Region', value: response.regionname }
                                                    ].map(({ label, value }) => (
                                                        <div className='grid' style={{ display: 'flex', alignItems: 'center', marginBottom: '40px' }} key={label}>
                                                            <strong style={{ marginRight: '20px', flex: '1' }}>{label} :</strong>
                                                            <p className="text-muted" style={{ flex: '2', margin: 0 }}>{value}</p>
                                                        </div>
                                                    ))}
                                                    {/*
                                                     * Author: Anuradha ,Date: 2026-02-05 
                                                     * Description: patient stastus hold lo vundi kani reason ravatam ledu
                                                     */}
                                                    
                                                    
                                                </div>
                                            </div>
                                        </Panel>
                                    ))}

                                    <Panel header="Chat" style={{ marginTop: '20px' }}>
                                        <ScrollPanel style={{ width: '100%', height: '200px' }} >

                                            {getdata2.map((item: any, index: any) => (
                                                <div key={item.id || index} style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                                    <img
                                                        className="direct-chat-img"
                                                        src={item.photo}
                                                        alt="User Avatar"
                                                        style={{ width: '50px', height: '50px', borderRadius: '50%', marginRight: '15px', border: '0.4px solid rgba(0, 0, 0, 0.125)' }}
                                                    />
                                                    <div>
                                                        <span style={{ marginLeft: '-10px' }}>{item.name}</span>
                                                        <span style={{ color: 'gray', marginLeft: '6px' }}>{item.date}</span>
                                                    </div>
                                                    <p style={{ marginLeft: '35px' }}>{item.msg}</p>
                                                </div>
                                            ))}

                                        </ScrollPanel>
                                        <div>
                                            <div className="grid">
                                                <div className='col-11'>
                                                    <InputText value={message} placeholder="Type Message ..." className="w-full mb-10" onChange={(e) => setMessage(e.target.value)} />
                                                </div>
                                                <span className="input-group-btn">
                                                    <div className='col-1'>
                                                        <Button severity="info" icon="pi pi-send" rounded outlined onClick={SendMessegeFunction} />

                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    </Panel>
                                    <Panel header="Document Upload" style={{ marginTop: '20px' }}>
                                        <div className="card flex flex-wrap justify-content-end">
                                            <Button label="Upload Docs" severity="info" onClick={() => setAdddocument(true)} />

                                        </div>
                                        <DataTable value={getdata4} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter}>
                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                            <Column field="doc_name" sortable header="Document Title"></Column>
                                            <Column header="Option" body={(rowData) => (
                                                <div className="options-buttons">
                                                    <Button icon="pi pi-eye" rounded outlined tooltip="View" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'blue', width: '2rem', height: '2rem' }} onClick={() => viewupload(rowData)} />
                                                </div>
                                            )}></Column>
                                        </DataTable>
                                    </Panel>

                                </div>
                                <Dialog header="Upload Document" visible={Adddocument} style={{ width: '30vw', height: '40' }} onHide={() => setAdddocument(false)} >
                                    <div className='row'>
                                        <div className='row'>
                                            <div className="grid pt-3">
                                                <div className="col-3">
                                                    <label htmlFor="name"   >Document Title:</label>
                                                </div>
                                                <div className="col md-3" >
                                                    <InputText id="name" style={{ width: '15vw' }} name="document" placeholder='Document-title' onChange={(e) => setDocument(e.target.value)} />
                                                </div>
                                                <div className="col-2" ></div>
                                            </div>
                                        </div>
                                        {/* <div className='row'>
                                            <div className="grid pt-3">
                                                <div className="col-3">
                                                    <label htmlFor="file" >Select File:</label>
                                                </div>
                                                <div className="col-3" >
                                                    <FileUpload mode="basic" id="fileToUpload" name="fileToUpload" customUpload accept="image/*" maxFileSize={1000000} uploadHandler={UploadManagerImage} auto />
                                                    {selectedFile && <p style={{ marginTop: '10px' }}>{selectedFile.name}</p>}

                                                </div>
                                            </div>
                                        </div> */}
                                        <div className='row'>
                                            <div className="grid pt-3">

                                                <div className="col-3">
                                                    <label htmlFor="file">Select File:</label>
                                                </div>

                                                <div className="col-3">
                                                    <FileUpload
                                                        mode="basic"
                                                        id="fileToUpload"
                                                        name="fileToUpload"
                                                        customUpload
                                                        accept="image/*"
                                                        maxFileSize={1000000}
                                                        uploadHandler={UploadManagerImage}
                                                        auto
                                                        onSelect={(e) => {
                                                            setFileName(e.files[0].name);
                                                        }}
                                                    />

                                                    {fileName && (
                                                        <div className="mt-2">
                                                            {fileName}
                                                        </div>
                                                    )}
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                    <br></br>
                                    <Button label="Close" className="ml-2" severity="secondary" onClick={close} />
                                    <Button label="ADD" severity="info" onClick={addDataAsync} style={{ float: 'right', marginRight: "30px" }} />
                                </Dialog>
                                <Dialog header="View" style={{ width: '50vw' }} visible={acceptfield} onHide={close}>
                                    <div className="modal-header">
                                        <Button icon="pi pi-times" className="p-button-text" />
                                    </div>
                                    <div className="modal-body">
                                        {view.map((response: any, index: number) =>
                                            <div key={index}>
                                                {response.filetype === 'photo' && <img src={response.displayfile} alt="Doc" width="100%" height="auto" />}
                                                {response.filetype !== 'photo' &&
                                                    <img src={response.displayfile} alt="Doc" width="100%" height="auto" />
                                                }
                                                {response.filetype === 'pdf' && (
                                                    <a href={response.displayfile} target="_blank" rel="noopener noreferrer">
                                                        Open PDF in New Tab
                                                    </a>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </Dialog>



                            </div>
                        </section>

                    </div>
                </div>
            </div>
            <Toast ref={toast} ></Toast>

        </div>


    )
}
